module.exports = __webpack_public_path__ + "img/icon-map-pin.7643a0eb.svg";